import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";

interface Props {
  userMessage: string;
  onTapCloseModal: () => void;
}

// OCR読み取り状況確認モーダル
export const ProcessStatusModal= (props: Props) => {
  const { 
    userMessage,
    onTapCloseModal,
  } = props;

  return (
    <BasePageModal
      title="OCR読み取り状況"
      handleClose={onTapCloseModal}
    >
      <p>{userMessage}</p>
    </BasePageModal>
  );
};
